import {api} from '../components/Base/App';

export default {
    create(ordersCreateCommand) {
        return api({
            method: 'post',
            url: '/rest/orders',
            data: ordersCreateCommand
        });
    },
    createWithFiles(ordersCreateCommand, files) {
        const formData = new FormData();

        files.forEach(item => {
            formData.append('file', item[1]);
        });
        formData.append('body', JSON.stringify(ordersCreateCommand));
        return api({
            method: 'post',
            url: '/rest/orders',
            headers: {
                'content-type': 'multipart/form-data'
            },
            data: formData
        });
    }
};



// WEBPACK FOOTER //
// ./src/api/Orders.js